import { NgModule, ModuleWithProviders, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { VapiConfiguration, VapiConfigurationParams } from './vapi-configuration';

import { VisualsService } from './services';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
    imports: [],
    exports: [],
    declarations: [],
    providers: [VisualsService, VapiConfiguration]
})
export class VapiModule {
    static forRoot(params: VapiConfigurationParams): ModuleWithProviders<VapiModule> {
        return {
            ngModule: VapiModule,
            providers: [
                {
                    provide: VapiConfiguration,
                    useValue: params
                }
            ]
        };
    }

    constructor() {
        const parentModule = inject(VapiModule, { optional: true, skipSelf: true });
        const http = inject(HttpClient, { optional: true });

        if (parentModule) {
            throw new Error('VapiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule!');
        }
    }
}
